import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Typography, Skeleton } from "antd";
import "./portal.css";
import Instruction from "./instruction";
import TestBoard from "./testBoard";
import Answer from "../answersheet/answer";
// import {
//   fetchTraineedata,
//   setTestDetsils,
//   fetchTestdata,
//   fetchPeanding,
// } from "../../../actions/traineeAction";
import {
  setTraineeTestDetails,
  updateTraineeTestAnswerSheet,
  updateTraineeTestQuestions,
} from "../../../reducers/trainee";
import queryString from "query-string";
import apis from "../../../services/Apis";
import { Post } from "../../../services/axiosCall";
import {
  fetchTestdata,
  fetchTraineedata,
  fetchTraineeTestAnswerSheet,
  fetchTraineeTestQuestions,
} from "../../../features/trianeeAsync";
import { fetchPending } from "../../../reducers/trainee";
import { useLocation } from "react-router-dom";
import Alert from "../../common/alert";
import { useSocket } from "../../../context/SocketContext";

const { Title } = Typography;

const MainPortal = () => {
  const trainee = useSelector((state) => state.trainee);
  // console.log(trainee);

  const dispatch = useDispatch();
  const location = useLocation();

  const params = queryString.parse(location.search);
  // console.log(params);

  const socket = useSocket();
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   socket.current = io(apis.BASE_LOCAL_URL);
  // }, []);

  useEffect(() => {
    if (!socket) return;

    const handleConnect = () => {
      if (loading) {
        socket.emit("join_test", {
          testid: params.testid,
          traineeid: params.traineeid,
          socketid: socket.id,
        });
      }
    };

    const handlePending = (data) => {
      console.log("Pending data", data);
      dispatch(fetchPending(data)); // ✅ Just pass the data
    };

    // Set up event listeners
    socket.on("connect", handleConnect);
    socket.on("pending", handlePending);

    // Cleanup function - removes ALL listeners for these events
    return () => {
      socket.off("connect", handleConnect);
      socket.off("pending", handlePending);
    };
  }, [loading, socket, dispatch, params.testid, params.traineeid]);

  useEffect(() => {
    dispatch(
      fetchTraineeTestAnswerSheet({
        testid: params.testid,
        userid: params.traineeid,
      })
    );
    dispatch(fetchTraineeTestQuestions(params.testid));
    dispatch(
      fetchTestdata({ testid: params.testid, traineeid: params.traineeid })
    );
    setLoading(true);
  }, [params.testid, params.traineeid]);

  useEffect(() => {
    dispatch(fetchTraineedata(params.traineeid));
    dispatch(
      setTraineeTestDetails({
        testid: params.testid,
        traineeid: params.traineeid,
      })
    );
  }, [params.testid, params.traineeid]);

  // UI conditions
  if (trainee.initialloading1 || trainee.initialloading2) {
    return ( 
      <div className="skeletor-wrapper">
        <Skeleton active />
        <Skeleton active />
      </div>
    );
  }

  if (trainee.invalidUrl) {
    window.location.href = "";
    return null;
  }

  if (trainee.LocaltestDone) {
    return <Answer />;
  }

  if (trainee.testconducted) {
    return (
      <div className="Test-portal-not-started-yet-wrapper">
        <div className="Test-portal-not-started-yet-inner">
          <Title
            className="Test-portal-not-started-yet-inner-message"
            level={4}
          >
            The Test is Over!
            <br /> You are late.
          </Title>
        </div>
      </div>
    );
  }

  if (!trainee.testbegins) {
    return (
      <div className="Test-portal-not-started-yet-wrapper">
        <div className="Test-portal-not-started-yet-inner">
          <Title
            className="Test-portal-not-started-yet-inner-message"
            level={4}
          >
            The test has not started yet. Wait for the tutor's instruction then
            refresh the page.
          </Title>
        </div>
      </div>
    );
  }

  if (trainee.startedWriting) {
    return <TestBoard loading={loading} />;
  }

  return <Instruction />;
};

export default MainPortal;
